import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Users, Wrench, Phone, MessageCircle } from 'lucide-react';
import type { HeaderProps } from '../../types/ui';

export default function Header({ showMobileMenu = true }: HeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-10 h-10 bg-blue-600 rounded-lg shadow-lg">
              <Wrench className="h-6 w-6 text-white transform rotate-45" />
            </div>
            <div className="flex flex-col">
              <span className="text-xl font-bold text-gray-900">Parakh</span>
              <span className="text-sm text-blue-600 font-medium -mt-1">Services</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <Link to="/services" className="nav-link">Services</Link>
            <Link to="/locations" className="nav-link">Locations</Link>
            <Link to="/brands" className="nav-link">Brands</Link>
            <Link to="/blog" className="nav-link">Blog</Link>
            <Link to="/partner" className="nav-link">Partner With Us</Link>
          </nav>

          {/* Contact Buttons - Desktop */}
          <div className="hidden lg:flex items-center space-x-4">
            <a
              href="tel:+918559929954"
              className="inline-flex items-center text-green-600 hover:text-green-700"
            >
              <Phone className="h-5 w-5 mr-2" />
              <span className="text-sm font-medium">Call</span>
            </a>
            <a
              href="https://wa.me/918559940369"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-green-600 hover:text-green-700"
            >
              <MessageCircle className="h-5 w-5 mr-2" />
              <span className="text-sm font-medium">WhatsApp</span>
            </a>
          </div>

          {/* Mobile menu button */}
          {showMobileMenu && (
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100"
              aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
            >
              {isMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          )}
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <Link
                to="/services"
                className="mobile-nav-link"
                onClick={() => setIsMenuOpen(false)}
              >
                Services
              </Link>
              <Link
                to="/locations"
                className="mobile-nav-link"
                onClick={() => setIsMenuOpen(false)}
              >
                Locations
              </Link>
              <Link
                to="/brands"
                className="mobile-nav-link"
                onClick={() => setIsMenuOpen(false)}
              >
                Brands
              </Link>
              <Link
                to="/blog"
                className="mobile-nav-link"
                onClick={() => setIsMenuOpen(false)}
              >
                Blog
              </Link>
              <Link
                to="/partner"
                className="mobile-nav-link text-blue-600"
                onClick={() => setIsMenuOpen(false)}
              >
                <Users className="h-5 w-5 mr-2 inline-block" />
                Partner With Us
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}